import { CookieSetOptions } from "universal-cookie";
import { COOKIE_EXPIRE_DAYS, COOKIE_PATH } from "@constants/cookies";

export default function createCookieOptions(domain?: string): CookieSetOptions {
  const expires = new Date();
  expires.setDate(expires.getDate() + COOKIE_EXPIRE_DAYS);

  return {
    path: COOKIE_PATH,
    expires,
    domain,
  };
}
